import { IKeyValueStore } from "@fokused-me/core";
import { INotepadState } from "./Model";

const NOTEPAD_STATE_ITEM_KEY = "NOTEPAD_STATE";

export const readNotepadState = (store: IKeyValueStore) => store.getItem<INotepadState>(NOTEPAD_STATE_ITEM_KEY);

export const writeNotepadState = (store: IKeyValueStore, value: INotepadState) =>
   store.setItem(NOTEPAD_STATE_ITEM_KEY, value);
